﻿export class Filters {
    public static clickHandler($: JQueryStatic): void {
        $(".attrax-post-tag-widget__heading-container").on(
            "click",
            function () {
                $(".tags-bg").toggleClass("filter-open");
            }
        );

        $(".attrax-post-categories-widget__heading-container").on(
            "click",
            function () {
                $(".cat-bg").toggleClass("filter-open");
            }
        );
    }
}
